"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripHtml = stripHtml;
exports.getRenderedText = getRenderedText;
/**
 * Strips HTML tags and decodes common entities from WordPress REST API text fields.
 */
function stripHtml(html) {
    if (!html || typeof html !== 'string')
        return '';
    return html
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .trim();
}
/** Extracts plain text from a WordPress title/excerpt field (string or `{rendered}` object). */
function getRenderedText(field) {
    if (!field)
        return '';
    const raw = typeof field === 'string' ? field : field.rendered;
    return stripHtml(raw);
}
//# sourceMappingURL=stripHtml.js.map